<template>
  <div id="page-forum" class="d-flex">
    <div v-if="user!=''">
      <MainBarMenu />      
    </div>
    <div class="layout-content container-fluid">
      <div class="row">
        <div class="col-12 pt-1" align="left">
          <div v-if="user!=''">
            <router-link :to='"/rightPetition/"+this.$route.params.id'>
              <b-button variant="light">
                &lt;&lt;&lt;--- Volver atras
              </b-button>
            </router-link>
          </div>
          <div v-else>
            <router-link :to='"/informer/"+this.$route.params.email'>
              <b-button variant="light">
                &lt;&lt;&lt;--- Volver atras
              </b-button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="page-forum">
        <div class="row mb-md-0 mb-0 mt-3 ml-4">
          <div class="col-10 text-left">
            <p class="title-3">FORO DE INFORMACIÓN PARA EL DERECHO DE PETICIÓN - {{this.$route.params.id}}</p>
          </div>
          <div class="col-2 text-left" v-if="user.core_role_id==8">
            <p class="p3">
              <b>Estado Foro</b>
            </p>
            <div class="d-flex p-2">
              <span v-if="statusForum=='open'" class="dotGreen"></span>
              <span v-else class="dotRed"></span>
              <select 
                class="custom-select my-1 mr-sm-2" 
                v-model="statusForum"
                @change="putStatusForum"
                >
                <option value="open">Activado</option>
                <option value="closed">Cerrado</option>
              </select>
            </div>            
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
              <div class="cont-forum-text d-flex flex-column justify-content-around mt-0 mt-md-1">
              <!-- .cont-title> -->
                <form
                  action="#"
                  class="form-forum mt-3 mb-2 mb-md-5 align-items-center"
                  >
                  <div class="row">
                    <div class="col-12 mb-md-5">
                      <p class="title-1"><b>Participantes:</b> 
                        <span v-for='(row, index) in foroContenido.participants' :key="index">
                          {{row.name}} ({{row.position}}) - 
                        </span>
                      </p>
                      <p class="title-1"><b>Responsable:</b> {{foroContenido.responsible.name}} - {{foroContenido.responsible.core_role.name}}</p>
                    </div>  
                  </div>
                  <div class="row">
                    <div class="col-12 mb-md-0">
                      <!--b-alert show><b>Petición: </b>
                        {{peticionForo.nombre}}: {{peticionForo.body}}
                      </b-alert-->
                    </div>  
                  </div>
                  <div class="row">
                    <div class="col-12 mb-md-0 mt-4 mx-0">
                      <p class="title-1"><b>Nueva Respuesta:</b>                      
                        <button type="button"
                           v-show="flagForo == false"
                          class="btn btn-outline-light"
                          v-on:click="flagForo = true"
                          >
                          <p class="p1 mt-3">Mostrar 	<b>&#x2228;</b></p>
                        </button>
                        <button type="button" 
                          v-show="flagForo == true"
                          class="btn btn-outline-light"
                          v-on:click="flagForo = false"
                          >
                          <p class="p1 mt-3">Ocultar 	<b>&#x2227;</b></p>
                        </button>                        
                      </p>
                      <div v-if="loading" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <div class="row shadow px-0 mb-0 bg-white rounded" v-show="flagForo == true">
                    <div class="col-12 col-lg-8 px-0">
                      <b-card-group deck>
                        <b-card
                          header=""
                          header-tag="header"
                          footer=""
                          footer-tag="footer"
                          title=""
                        >
                          <template #header>
                              <p class="title-1"><b>{{nameParticipant}} - {{positionParticipant}}</b></p>
                          </template>
                          <b-card-text>
                            <textarea class="p1" v-model="msjForo" cols="85"></textarea>
                          </b-card-text>
                          <template #footer>
                            <p class="title-1" align="center">
                              <button type="button" 
                                class="btn btn-darkblue-1"
                                v-on:click="addInfoForo"
                                :disabled="(msjForo == '') ? true : false"
                                >
                                Añadir respuesta
                              </button>
                            </p>
                            <div v-if="loading" class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </template>
                        </b-card>
                      </b-card-group>
                    </div>
                    <div class="col-12 col-lg-4 pr-0 pr-0" >
                      <b-card-group>
                        <b-card 
                          title="" 
                          header=""
                          header-tag="header" 
                          footer-tag="footer">
                            <template #header>
                              <p class="title-1" align="center"><b>Adjuntar archivos ({{filesResponse.length}})</b></p>
                            </template>
                            <b-card-text>
                              <div class="row">
                                <div class="col-8 text-center">
                                  <table class="table table-bordered table-striped table-hover table-sm text-left">
                                    <thead>
                                      <tr class="p1">
                                        <th>No.</th>
                                        <th>Nombre</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(row, index) in this.filesResponse" :key="index">
                                        <th><p class="p1">{{index+1}}</p></th>
                                        <th><p class="p1">{{row.name}}</p></th>
                                        <th>
                                          <p class="p1">
                                            <button 
                                              type="button" 
                                              class="btn btn-light"
                                              v-on:click="deleteFileL(index)"
                                              >
                                                <img src="@/assets/images/icons/trash.svg" />
                                            </button>
                                          </p>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td colspan="3">
                                          <div class="file-upload-img">
                                            <input 
                                              type="file"
                                              id="fileDocu"
                                              @change="fileSelected"
                                              multiple
                                              required
                                            />                                    
                                            <p class="p1">+Subir archivos</p>
                                            <!--img src="@/assets/images/settler/uploadFile.jpg" /-->
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!--div class="col-4 text-left">
                                  
                                </div-->
                              </div>
                            </b-card-text>
                        </b-card>
                      </b-card-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-md-0 mt-5 mx-0">
                      <p class="title-1"><b>Conversación:</b></p>
                    </div>  
                  </div>
                  
                  <div class="row  shadow px-0 mb-0 bg-white rounded" v-for="(row, index) in foroContenido.comments" :key="index">
                    <div class="col-12 col-lg-8 pr-0 pl-0 mt-0">
                      <b-card-group deck>
                        <b-card
                          header=""
                          header-tag="header"
                          footer=""

                          footer-tag="footer"
                          title=""
                        >
                          <template #header>
                              <p class="title-1"><b>{{row.participant.name}} - {{row.participant.position}}</b>
                              <span align="right">({{row.created_at.substring(0,10)}})</span></p>
                          </template>
                          <b-card-text>
                            <p class="p1">{{row.message}}</p>
                          </b-card-text>
                          
                          <span v-if="flagResponse[row.id] == true">
                            <div class="row" v-for="(respuesta, index) in row.comments" :key="index">
                              <div class="col-12 col-lg-12 pr-0 pl-5 mt-4">
                                <b-card-group deck>
                                  <b-card                                    
                                    header-tag="header"
                                  >
                                    <template #header>
                                        <p class="title-1"><b>{{respuesta.participant.name}}</b>-
                                        <span align="right">{{respuesta.created_at.substring(0,10)}}</span></p>
                                    </template>
                                    <b-card-text>
                                      <p class="p1">{{respuesta.message}}</p>
                                    </b-card-text>                                    
                                  </b-card>
                                </b-card-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-lg-12 pr-0 pl-5 mt-4">
                                <textarea class="p1" 
                                  v-model="responseForo[row.id]" 
                                  cols="83"
                                  placeholder="Escribe aqui tu respuesta"
                                ></textarea>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-lg-12 pr-0 pl-5 mt-0 text-right pr-5">
                                <button type="button" 
                                  class="btn btn-outline-light"
                                  v-on:click="addResponse(row.id)"
                                  :disabled="(responseForo[row.id] == '') ? true : false"
                                  >
                                  <p class="p1" style="text-decoration: underline;">Añadir respuesta</p>
                                </button>
                              </div>
                            </div>
                          </span>

                          <template #footer>
                            <p class="title-1" align="center">
                              {{row.comments.length}}
                              Respuestas | 
                              <button type="button" v-show="flagResponse[row.id] == false"                              
                                class="btn btn-outline-link btn-lg"
                                v-on:click="showResponse(row.id,'true')"
                                >
                                ver
                              </button>
                              <button type="button" v-show="flagResponse[row.id] == true"                              
                                class="btn btn-outline-link btn-lg"
                                v-on:click="showResponse(row.id,'false')"
                                >
                                Ocultar
                              </button>
                            </p>
                          </template>
                        </b-card>
                      </b-card-group>
                    </div>
                    <div class="col-12 col-lg-4 pr-0 pr-0 mt-0">
                      <b-card-group>
                        <b-card 
                          title="" 
                          header=""
                          header-tag="header" 
                          footer-tag="footer">
                            <template #header>
                              <p class="title-1" align="center"><b>Archivos Adjuntos ({{row.files.length}})</b></p>
                            </template>
                            <b-card-text>
                              <div class="row">
                                <div class="col-8 text-center">
                                  <table class="table table-bordered table-striped table-hover table-sm text-left">
                                    <thead>
                                      <tr class="p1">
                                        <th>No.</th>
                                        <th>Nombre</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(file, index) in row.files" :key="index">
                                        <a :href="serverPath+'/'+file.path" target="_blank">
                                          <th><p class="p1">{{index+1}}</p></th>
                                          <th><p class="p1">{{file.path}}</p></th>
                                        </a>
                                        <th>
                                          <p class="p1">
                                            <button 
                                              type="button" 
                                              class="btn btn-light"
                                              v-on:click="deleteFileS(file.id)"
                                              >
                                                <img src="@/assets/images/icons/trash.svg" />
                                            </button>
                                          </p>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td colspan="3">
                                          <div class="file-upload-img">
                                            <input 
                                              type="file"
                                              :id="'fileDocu'+row.id"
                                              @change="Sendfile(row.id)"
                                              required
                                            />
                                            <div v-if="!loading">
                                              <p class="p3" align="right">+Subir archivo</p>
                                            </div>
                                            <div v-else-if="loading" class="spinner-border" role="status">
                                              <span class="sr-only">Loading...</span>
                                            </div>
                                            <!--img src="@/assets/images/settler/uploadFile.jpg" /-->
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>                                
                              </div>

                              <!--p class="p3" align="left" v-for="(file, index) in row.files" :key="index">
                                <b>{{ index+1 }}) {{ file.path }}</b>
                              </p>
                              <div class="file-upload-text">
                                <input 
                                  type="file"
                                  :id="'fileDocu'+row.id"
                                  @change="Sendfile(row.id)"
                                  required
                                />
                                <p class="p3" align="right">+Subir archivo</p>
                              </div-->

                            </b-card-text>
                        </b-card>
                      </b-card-group>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          <!-- .col -->
          </div>
        <!-- .row -->
        </div>
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Forum",
  components: {
    MainBarMenu,    
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      nameParticipant: '',
      positionParticipant: '',
      flagForo: true,
      flagResponse: [],
      idResponse: '',
      email: '',
      filesResponse:  [],
      statusSolicitud: '',      
      modalsLocal: [],
      msjForo: '',

      peticionForo: {id:1, nombre:'Jorge Beltran', body:'Se requiere evidencia para responder este derecho de petición'},
      nameFile: '',
      filesSelected: [],

      responseForo: [],
      foroContenido: [],
      statusForum: '',
    };
  },
  beforeMount(){
    /*var data = [];
    data[0] = this.$route.params.id;
    data[1] = this.$route.params.id_forum;
    data[2] = {'email':this.$route.params.email}

    this.actValidateUserFrm(data);*/
    this.actGetInfoForum(this.$route.params.id_forum).then(() =>{
      this.foroContenido = this.infoForum.data;
      this.statusForum = this.infoForum.data.status;
      this.foroContenido.comments.forEach(row => {
        this.flagResponse[row.id] = false;
      });
    });

    this.actGetInformerInfo(this.$route.params.email).then(() =>{
      this.nameParticipant = this.informerInfo.data[0][0].participant.name;
      this.positionParticipant = this.informerInfo.data[0][0].participant.position;
    });
   
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRightPetition", [
      "infoForum",
      "informerInfo",
      "loading"
    ]),
    
  },
  methods: {
    ...mapActions("modRightPetition", [
      "actGetInfoForum",
      "actSendComment",
      "actSendFilesForum",
      "actDeleteFileForum",
      "actGetInformerInfo",
      "actPutStatusForum",
      "actValidateUserFrm",
    ]),

    addInfoForo(){
      var formData = new FormData();
      var data = [];
      //const files = document.querySelector('#fileDocu');

      formData.append("email", this.$route.params.email);
      formData.append("message", this.msjForo);
      for(let i=0; i<this.filesResponse.length; i++){
        formData.append("files[]", this.filesResponse[i]);
      }      
      data[0] = this.$route.params.id_forum;
      data[1] = formData;
      
      this.actSendComment(data).then(() =>{
        this.actGetInfoForum(this.$route.params.id_forum).then(() =>{
          this.foroContenido = this.infoForum.data;
          this.foroContenido.comments.forEach(row => {
            this.flagResponse[row.id] = false;
          });
        });
      });

      this.msjForo = '';
      this.filesResponse = [];
      this.flagForo = false;
    },

    addResponse(id){
      var data = [];      
      data[0] = this.$route.params.id_forum;
      data[1] = {
        "email": this.$route.params.email,
        "message": this.responseForo[id],
        "forum_comment_id": id
      };
      
      this.actSendComment(data).then(() =>{
        this.actGetInfoForum(this.$route.params.id_forum).then(() =>{
          this.foroContenido = this.infoForum.data;
          this.responseForo[id] = '';
        });
      });      
    },

    showResponse(id,flag){
      this.$set(this.flagResponse, id, (flag == 'true') ? true : false);
    },

    Sendfile(idComment){      
      var formData = new FormData();
      var data = [];
      const file = document.querySelector('#fileDocu'+idComment);
      this.nameFile = file.files[0].name;
      //alert(file.files[0].name);
      formData.append("file[]", file.files[0]);
      formData.append("email", this.$route.params.email);

      data[0] = idComment;
      data[1] = formData
      
      this.actSendFilesForum(data).then(() =>{
        this.actGetInfoForum(this.$route.params.id_forum).then(() =>{
          this.foroContenido = this.infoForum.data;
          /*this.foroContenido.comments.forEach(row => {
            this.flagResponse[row.id] = false;
          });*/
        });
      });
    },

    fileSelected(){
      const dato = document.querySelector('#fileDocu');      
      for(let i=0; i<dato.files.length; i++){
        this.filesResponse.push(dato.files[i]);
      }
    },

    deleteFileL(key){ // Borrado local
      this.filesResponse.splice( key, 1 );
      //this.filesSelected = this.filesSelected.filter((item) => item.id !== id);
    },

    deleteFileS(id){ // Borrado Servidor
      this.$bvModal.msgBoxConfirm('¿Desea borrar este archivo del servidor?',
        {
          title: 'Atención al mensaje:',
          size: 'sm',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'CONTINUAR',
          cancelTitle: 'CANCELAR',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if(value == true){
            var data = [];
            data[0] = this.$route.params.id_forum;
            data[1] = {
              'email': this.$route.params.email,
              'file_id': id
            }

            this.actDeleteFileForum(data).then(() =>{
              this.actGetInfoForum(this.$route.params.id_forum).then(() =>{
                this.foroContenido = this.infoForum.data;
              });
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    putStatusForum(){
      let data = [];
      data[0] = this.$route.params.id_forum;
      data[1] = {
        'status': this.statusForum
      }
      this.actPutStatusForum(data);
    }
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-forum {
  .title-3 {
        font-size: 22px;
        font-weight: bold;
        text-align: left;
        color: #1C3A4E;
      }
  .cont-forum-text {
    
    .title-1 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
    }
    .title-2 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
      align-content: center;
      text-align: center;
    }
    .title-3 {
      font-family: "Open Sans";
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      color: #1C3A4E;
      align-content: center;
      text-align: right;
    }
    
    .form-forum {      
      .boton1 {
        background: #ffffff;
        color: #1C3A4E;
        border-color: #1C3A4E;
        font-family: "Poppins";
        border-radius: 5px;
        height: 32px;
        width: 170px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 15%;
        padding-right: 5%;
        &:hover {
          background: darken(#f6f8fa, 5);
        }
      }
      .boton2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 50px;
        height: 32px;
        width: 150px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#7a7c7e, 5);
        }
      }
      .tabla1{  
        border-radius: 5px;
        border: 3px solid #ced2d3;
        border-color: #ced2d3;
        background: #ced2d3;  
        -moz-border-radius: 6px;
        border-collapse: separate;
        border-spacing: 0px;
        width: 530px;
        align-content: center;
        text-align: center;
      }
      .td1 {
        background: #ced2d3;
        color: #454545;
        font-family: "Open Sans";
        font-weight: normal;
        font-size: 12px;
        line-height: 19px;
        padding-left: 1%;
        padding-right: 1%;
        width: 100px;
      }
      .p1 {
        font-family: "Open Sans";
        font-style: normal;        
        font-size: 13px;
        line-height: 16px;
        color: #1C3A4E;
      } 
    }
  }
  .button2 {
    background: #ffffff;
    color: #8d9092;
    border-color: #ffffff;
    font-family: "Poppins";
    height: 32px;
    width: 120px;
    font-size: 14px;
    text-align: center !important;  
    padding-left: 2%;
    padding-right: 2%;
    &:hover {
      background: darken(#ffffff, 5);
    }
  }
  .button4 {
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    color: initial;
  }  
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 16px;
    color: #303030;
    padding-left: 5%;
    text-align: right;
    vertical-align: bottom;
    text-decoration: underline;
  }
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #454545;
  }

  .center {
    display: flex;
    align-items: center;
  }
  .img1 {
    width: 90px;
    height: 130px;
    //position: absolute;
    left: 50%;
    top: 50%; 
    margin-left: -2px;
    margin-top: -2px;
    //float: left;
    //fill: white;
    //clear: right;
    align-content: center;
  }
  .centerImg {
    width: 19px;
    height: 19px;
    //position: absolute;
    //left: 50%;
    top: 100%; 
    //margin-left: -8px;
    //margin-top: 8px;
    float: left;
    fill: white;
    //clear: right;
  }
  .row1 {
    align-content: center;
    background: #ced2d3;
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
    margin: 0px 20px 0px 3px;
  }

  .cont-first-icon {
    font-size: 80px;
    color: #ffffff;
  }

  .header {
    background-color: #1C6776;
    font-family: "Poppins";
    padding: 0px;
    text-align: center;
    color: white;
    font-size: 20px;
  }

  .file-upload-img{
    width:290px;
    height:100px;
    //border-style: dashed;
    text-align: center;
    display: flex;
    align-items: center;
    cursor:pointer;
  }
  .file-upload-img img{
      width:100%;
      height:100%;      
  }
  .file-upload-text{
    text-align: right;
    display: block;
    align-items: right;
    cursor:pointer;
  }
  
  input[type="file"]{
      opacity:0;
      filter:alpha(opacity=0);
      display:block;
      width:260px;
      height:100px;
      position:absolute;
      cursor:pointer;
  }
  .dotGreen {
    height: 25px;
    width: 30px;
    background-color: green;
    border-radius: 50%;
    display: inline-block;
  }
  .dotRed {
    height: 25px;
    width: 30px;
    background-color: Red;
    border-radius: 50%;
    display: inline-block;
  }
}

</style>